// extracted by mini-css-extract-plugin
export var button = "NewsSidebar-module--button--951b9";
export var cta = "NewsSidebar-module--cta--cb243";
export var newsletter = "NewsSidebar-module--newsletter--85ed2";
export var overlapping = "NewsSidebar-module--overlapping--23e2f";
export var sidebar = "NewsSidebar-module--sidebar--f3aea";
export var title = "NewsSidebar-module--title--75550";